import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, ChevronDown } from 'lucide-react';
import heroBg from '@/assets/hero-bg.jpg';
import logo from '@/assets/logo.png';

export function Hero() {
  const scrollToContent = () => {
    window.scrollTo({
      top: window.innerHeight * 0.85,
      behavior: 'smooth',
    });
  };

  return (
    <section className="relative min-h-[55vh] md:min-h-[60vh] flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={heroBg}
          alt=""
          fetchPriority="high"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-l from-foreground/90 via-foreground/70 to-foreground/40" />
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-xl mx-auto text-center">
          {/* Logo */}
          <img 
            src={logo} 
            alt="Barbor Meals" 
            className="h-16 md:h-20 mx-auto mb-4 animate-fade-in-down transition-all duration-500 hover:scale-110 hover:drop-shadow-[0_0_25px_rgba(255,255,255,0.6)] cursor-pointer"
            style={{ animationDelay: '0.2s' }}
          />
          
          <h1 
            className="text-3xl md:text-5xl lg:text-6xl font-bold text-primary-foreground mb-4 leading-tight animate-blur-in"
            style={{ animationDelay: '0.4s' }}
          >
            תזונה בריאה.{' '}
            <span className="text-accent bg-gradient-to-r from-accent to-yellow-300 bg-clip-text text-transparent animate-gradient-x bg-[length:200%_auto]">
              טעם מושלם.
            </span>
          </h1>
          
          <p 
            className="text-base md:text-lg text-primary-foreground/85 mb-6 leading-relaxed animate-fade-in-up"
            style={{ animationDelay: '0.6s' }}
          >
            מנות בריאות ומאוזנות, עשירות בחלבון וטעימות במיוחד
          </p>

          <div 
            className="flex justify-center animate-scale-in-bounce"
            style={{ animationDelay: '0.8s' }}
          >
            <Link to="/meals">
              <Button 
                size="lg" 
                className="group text-base px-8 py-6 relative overflow-hidden transition-all duration-300 hover:shadow-[0_0_30px_rgba(var(--primary),0.5)]"
              >
                <span className="relative z-10 flex items-center">
                  צפו בתפריט שלנו
                  <ArrowLeft className="ms-2 h-5 w-5 transition-transform group-hover:translate-x-2" />
                </span>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700" />
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToContent}
        className="absolute bottom-6 left-1/2 -translate-x-1/2 text-primary-foreground/60 hover:text-primary-foreground transition-colors animate-bounce-soft cursor-pointer"
        aria-label="גלול למטה"
      >
        <ChevronDown className="h-7 w-7" />
      </button>
    </section>
  );
}
